import * as React from 'react'

/**
 * @param {React.ComponentProps<'svg'>}props
 * @return {JSX.Element} Spinning Circle
 */
export const Spinner: React.FC<React.ComponentProps<'svg'>> = (props) => {
  return (
    <svg
      className="animate-rotate  stroke-[url('#loaderGradient')] block self-center m-4 my-auto"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      height="16px"
      width="16px"
    >
      <defs>
        <radialGradient id="loaderGradient">
          <stop offset="85%" stopColor="hsl(243, 40%, 30%)" />
          <stop offset="90%" stopColor="hsl(173, 20%, 30%)" />
          <stop offset="95%" stopColor="hsl(153, 70%, 40%)" />
          <stop offset="100%" stopColor="hsl(53, 20%, 70%)" />
        </radialGradient>
      </defs>
      <path
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
